import request from "@/utils/request";


// 问题交接-列表
export function questionHandoverApi(data) {
    return request({
      url: "/admin/mission",
      method: "get",
      params: data
    });
  }

// 问题交接-添加
export function questionAddApi(data) {
    return request({
      url: "/admin/mission",
      method: "post",
      data
    });
  }

// 问题交接 - 发布任务
export function publishTaskApi(data) {
    return request({
      url: "/admin/send_mission",
      method: "post",
      data
    });
  }

// 问题交接-删除
export function deleteApi(data) {
    return request({
      url: "/admin/mission/" + data.id,
      method: "delete",
      data
    });
  }

// 问题交接-记录
export function questionLogApi(data) {
    return request({
      url: "/admin/mission_log",
      method: "get",
      params: data
    });
  }

// 问题交接 - 获取列表下拉框类型
export function getMissionSelectApi(data) {
    return request({
      url: "/admin/get_mission_list_select",
      method: "get",
      params: data
    });
  }

// 问题交接 - 加入接管
export function acceptMissionApi(data) {
    return request({
      url: "/admin/accept_mission",
      method: "post",
      params: data
    });
  }

// 取消接管
export function cancelMissionApi(data) {
  return request({
    url: "/admin/cancel_mission",
    method: "post",
    params: data
  });
}

// 问题交接 - 进行交接 - 获取
export function getHandoverApi(data) {
    return request({
      url: "/admin/mission/" + data.id,
      method: "get",
      data
    });
  }

// 问题交接 - 进行交接 - 提交
export function putHandoverApi(data) {
    return request({
      url: "/admin/mission/" + data.id,
      method: "put",
      data
    });
  }

// 问题交接 - 结束任务
export function finishTaskApi(data) {
    return request({
      url: "/admin/finish_mission",
      method: "post",
      data
    });
  }

// 问题交接 - 获取通知用户列表
export function getAdminListApi() {
    return request({
        url: "/admin/get_notice_admin_select",
        method: "get",
    });
}

export function getAdminUserListApi(data) {
  return request({
    url: "/admin/user_order_list",
    method: "get",
    params: data
  });
}